import { useCallback } from 'react';

import { useCommentActions } from '@web/newsfeed/Article/ArticleComments/hooks/useCommentActions';
import { SubmitParams } from '@web/richText/TextEditorInner/TextEditorInner';
import { useCommentEditPersonas } from '@web/newsfeed/Article/ArticleComments/hooks/useCommentEditPersonas';

export const useArticleCommentEditor = (articleId: number, pageId: number) => {
  const { addComment } = useCommentActions();
  const { mentionPersonas } = useCommentEditPersonas(pageId);

  const onSubmit = useCallback(
    ({ text: content, attachments }: SubmitParams) => {
      addComment({
        articleId,
        pageId,
        content,
        attachments,
      });
    },
    [addComment, articleId, pageId]
  );

  return { onSubmit, mentionPersonas };
};
